import * as S from './styled';

function Grid ({ children }) {
  return <S.Container>
    {children}
  </S.Container>;
}

export default Grid;
